<template>
  <div v-if="warranty && isInExperiment">
    <template v-if="showItemPrice">
      <div class="whitespace-nowrap">+ {{ formatCents(warranty.price) }}</div>
    </template>
    <template v-else>
      <div class="whitespace-nowrap">+ {{ formatCents(warranty.subtotal) }}</div>
    </template>
    <div class="font-normal text-xs">Protection Plan</div>
  </div>
</template>

<script setup lang="ts">
const { isInExperiment } = useExtendExperiment()

defineProps<{
  warranty: Warranty
  showItemPrice?: Boolean
}>()
</script>
